"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentTypes = exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType["PayPal"] = "Paypal";
    PaymentType["StripeUK"] = "StripeUK";
    PaymentType["StripeUS"] = "StripeUS";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
exports.paymentTypes = Object.keys(PaymentType).map(key => PaymentType[key]);
//# sourceMappingURL=payment-type.js.map